<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">{{ modalData.title }}</div>
    <div class="inputs">
      <span>Entry code:</span>
      <input class="single-input" type="text" v-model="code" />
    </div>
    <div class="inputs">
      <span>Entry password:</span>
      <input class="single-input" type="text" v-model="pass" />
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        {{ $t('main.confirm') }}
      </div>
      <div @click="closeModal()" class="btn inv">
        {{ $t('main.cancel') }}
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'editWorkSetup',
  data () {
    return {
      code: null,
      pass: null
    }
  },
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  methods: {
    async ok () {
      if (!this.code || !this.pass) {
        this.$toast.error('You need to fill out the fields "Entry code" and "Entry password".', {
          duration: 8000
        })
        return
      }
      let params = {
        wrk_code: this.code,
        wrk_password: this.pass
      }
      try {
        let res = await api.getWorkData(params)
        this.modalData.ok(res.data.data, params)
        eventBus.$emit('closeModal')
      } catch (e) {
        if (e.response.data.message === 'invalid-credentials') {
          this.$toast.error('Invalid "Entry code" or "Entry password".', {
            duration: 8000
          })
        } else if (e.response.data.message === 'competition-expired') {
          this.$toast.error('The deadline for entry submission has passed.', {
            duration: 8000
          })
        } else {
          this.$toast.error('There has been an error.', {
            duration: 8000
          })
        }
      }
    },
    closeModal () {
      if (this.modalData.cancel) {
        this.modalData.cancel()
      }
      eventBus.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/btnStyles.scss';
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import '@/assets/scss/scrollbarStyles.scss';
  @include scrollbar;
  @import '@/assets/scss/cardStyles.scss';

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
